var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6135 5.24408C16.939 4.91864 17.4665 4.91864 17.7919 5.24408C18.1173 5.56951 18.1173 6.09703 17.7919 6.42246L9.45858 14.7558C9.13314 15.0812 8.60563 15.0812 8.28019 14.7558L4.11352 10.5891C3.78809 10.2637 3.78809 9.73618 4.11352 9.41074C4.43896 9.08531 4.96647 9.08531 5.29191 9.41074L8.86938 12.9882L16.6135 5.24408Z",
    fill: "#4FD1DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.bdbabd7c4115cfa674a5f07e5621d78a.svg";
export { ForwardRef as ReactComponent };